<main class="mx-auto w-full max-w-5xl px-0 pb-12 text-strong sm:px-2">
    <button type="button" (click)="navigateBackToDashboard()"
            class="mb-5 inline-flex min-h-[40px] items-center gap-2 border-0 bg-transparent p-0 text-sm font-medium text-slate-600 hover:text-primary">
        <i class="bi bi-arrow-left" aria-hidden="true"></i> Torna alla dashboard
    </button>

    <header class="mb-6">
        <h1 class="m-0 text-2xl font-bold tracking-tight text-strong sm:text-3xl">Convocazioni</h1>
        <p class="mb-0 mt-2 max-w-2xl text-sm leading-6 text-slate-600">
            I prossimi appuntamenti della tua squadra e lo storico delle convocazioni passate.
            Apri una convocazione per vedere orari, luogo e chi è convocato.
        </p>
    </header>

    <!-- Tab prossime / passate -->
    <div class="mb-6 grid grid-cols-2 gap-1 rounded-xl border border-slate-200 bg-white p-1 sm:inline-grid sm:min-w-[22rem]"
         role="tablist" aria-label="Filtra convocazioni">
        <button type="button" role="tab" id="tab-upcoming" aria-controls="panel-upcoming"
                [attr.aria-selected]="activeTab === 'upcoming'"
                (click)="selectTab('upcoming')"
                class="inline-flex min-h-[40px] items-center justify-center gap-2 rounded-lg border-0 px-3 text-sm font-semibold transition"
                [ngClass]="activeTab === 'upcoming' ? 'bg-primary text-white shadow-sm' : 'bg-transparent text-slate-600 hover:bg-slate-100'">
            <i class="bi bi-calendar-event" aria-hidden="true"></i>
            Prossime
            <span *ngIf="!upcomingLoading"
                  class="grid h-5 min-w-[20px] place-items-center rounded-full px-1.5 text-[11px] font-bold leading-none"
                  [ngClass]="activeTab === 'upcoming' ? 'bg-white/25 text-white' : 'bg-slate-100 text-slate-600'">
                {{ upcoming.length }}
            </span>
        </button>
        <button type="button" role="tab" id="tab-past" aria-controls="panel-past"
                [attr.aria-selected]="activeTab === 'past'"
                (click)="selectTab('past')"
                class="inline-flex min-h-[40px] items-center justify-center gap-2 rounded-lg border-0 px-3 text-sm font-semibold transition"
                [ngClass]="activeTab === 'past' ? 'bg-primary text-white shadow-sm' : 'bg-transparent text-slate-600 hover:bg-slate-100'">
            <i class="bi bi-clock-history" aria-hidden="true"></i>
            Passate
            <span *ngIf="!pastLoading"
                  class="grid h-5 min-w-[20px] place-items-center rounded-full px-1.5 text-[11px] font-bold leading-none"
                  [ngClass]="activeTab === 'past' ? 'bg-white/25 text-white' : 'bg-slate-100 text-slate-600'">
                {{ pastTotal }}
            </span>
        </button>
    </div>

    <!-- Prossime -->
    <section *ngIf="activeTab === 'upcoming'" id="panel-upcoming" role="tabpanel" aria-labelledby="tab-upcoming">
        <ng-container *ngIf="upcomingLoading">
            <ng-container *ngTemplateOutlet="skeleton; context: { highlight: true }"></ng-container>
        </ng-container>

        <ng-container *ngIf="!upcomingLoading && upcoming.length === 0">
            <ng-container *ngTemplateOutlet="emptyState; context: {
                icon: 'bi-calendar-x',
                title: 'Nessuna convocazione in programma',
                text: 'Quando l\'allenatore pubblicherà una nuova convocazione la troverai qui.'
            }"></ng-container>
        </ng-container>

        <ng-container *ngIf="!upcomingLoading && nextConvocation as c">
            <h2 class="mb-3 text-xs font-bold uppercase tracking-wide text-slate-500">Prossimo appuntamento</h2>

            <article class="mb-8 overflow-hidden rounded-xl border border-primary bg-white transition hover:shadow-md">
                <a [routerLink]="detailRouteBase.concat(c.id)"
                   class="flex flex-col gap-4 p-4 !text-strong !no-underline sm:flex-row sm:items-center sm:gap-5 sm:p-5"
                   [attr.aria-label]="'Apri la convocazione ' + c.title">
                    <div class="flex items-center gap-3 sm:block sm:shrink-0">
                        <span class="grid h-16 w-16 shrink-0 place-content-center rounded-xl bg-primary text-center text-white sm:h-20 sm:w-20">
                            <span class="text-[11px] font-semibold uppercase leading-none opacity-90">{{ c.date | date : 'MMM' : undefined : 'it' }}</span>
                            <span class="text-2xl font-bold leading-tight sm:text-3xl">{{ c.date | date : 'd' : undefined : 'it' }}</span>
                            <span class="text-[11px] font-medium capitalize leading-none opacity-90">{{ c.date | date : 'EEE' : undefined : 'it' }}</span>
                        </span>
                        <span class="flex flex-wrap gap-2 sm:hidden">
                            <ng-container *ngTemplateOutlet="countdownBadge; context: { $implicit: c }"></ng-container>
                            <ng-container *ngTemplateOutlet="invitedBadge; context: { $implicit: c }"></ng-container>
                        </span>
                    </div>

                    <div class="min-w-0 flex-1">
                        <div class="mb-1 hidden flex-wrap gap-2 sm:flex">
                            <ng-container *ngTemplateOutlet="countdownBadge; context: { $implicit: c }"></ng-container>
                            <ng-container *ngTemplateOutlet="invitedBadge; context: { $implicit: c }"></ng-container>
                        </div>
                        <p *ngIf="c.categoryName" class="mb-0.5 text-xs font-semibold uppercase tracking-wide text-slate-500">{{ c.categoryName }}</p>
                        <h3 class="m-0 text-lg font-bold leading-snug text-strong sm:text-xl">{{ c.title }}</h3>

                        <dl class="mb-0 mt-3 grid gap-2 text-sm sm:grid-cols-2">
                            <div class="flex items-start gap-2">
                                <dt class="sr-only">Data e ora</dt>
                                <i class="bi bi-clock mt-0.5 shrink-0 text-primary" aria-hidden="true"></i>
                                <dd class="m-0 capitalize">
                                    {{ c.date | date : 'EEEE d MMMM' : undefined : 'it' }}, ore <span class="font-semibold">{{ c.date | date : 'HH:mm' : undefined : 'it' }}</span>
                                </dd>
                            </div>
                            <div class="flex min-w-0 items-start gap-2">
                                <dt class="sr-only">Luogo</dt>
                                <i class="bi bi-geo-alt mt-0.5 shrink-0 text-primary" aria-hidden="true"></i>
                                <dd class="m-0 min-w-0">
                                    <span class="block font-semibold">{{ c.location || '—' }}</span>
                                    <span *ngIf="fullAddress(c)" class="block text-xs text-slate-500">{{ fullAddress(c) }}</span>
                                </dd>
                            </div>
                        </dl>

                        <p *ngIf="c.description && c.description !== '—'"
                           class="mb-0 mt-3 line-clamp-2 text-sm leading-6 text-slate-600">{{ c.description }}</p>
                    </div>

                    <i class="bi bi-chevron-right hidden shrink-0 text-slate-400 sm:block" aria-hidden="true"></i>
                </a>

                <div *ngIf="isLink(c.linkPosition)"
                     class="flex border-0 border-t border-solid border-slate-100 bg-slate-50 px-4 py-2 sm:px-5">
                    <a [href]="c.linkPosition" target="_blank" rel="noopener noreferrer"
                       class="inline-flex min-h-[40px] items-center gap-2 text-sm font-semibold !text-primary hover:underline">
                        <i class="bi bi-pin-map" aria-hidden="true"></i> Apri sulla mappa
                    </a>
                </div>
            </article>

            <ng-container *ngIf="laterUpcomingGroups.length > 0">
                <h2 class="mb-3 text-xs font-bold uppercase tracking-wide text-slate-500">In seguito</h2>
                <ng-container *ngTemplateOutlet="groupedList; context: { groups: laterUpcomingGroups, past: false }"></ng-container>
            </ng-container>
        </ng-container>
    </section>

    <!-- Passate -->
    <section *ngIf="activeTab === 'past'" id="panel-past" role="tabpanel" aria-labelledby="tab-past">
        <ng-container *ngIf="pastLoading">
            <ng-container *ngTemplateOutlet="skeleton; context: { highlight: false }"></ng-container>
        </ng-container>

        <ng-container *ngIf="!pastLoading && past.length === 0">
            <ng-container *ngTemplateOutlet="emptyState; context: {
                icon: 'bi-clock-history',
                title: 'Nessuna convocazione passata',
                text: 'Lo storico delle convocazioni concluse comparirà qui.'
            }"></ng-container>
        </ng-container>

        <ng-container *ngIf="!pastLoading && past.length > 0">
            <ng-container *ngTemplateOutlet="groupedList; context: { groups: pastGroups, past: true }"></ng-container>

            <div *ngIf="hasMorePast" class="mt-6 flex justify-center">
                <button type="button" (click)="loadMorePast()" [disabled]="pastLoadingMore"
                        class="btn welldone-btn-light inline-flex min-h-[44px] w-full items-center justify-center gap-2 sm:w-auto">
                    <span *ngIf="pastLoadingMore" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    <i *ngIf="!pastLoadingMore" class="bi bi-arrow-down-circle" aria-hidden="true"></i>
                    Mostra altre ({{ pastTotal - past.length }})
                </button>
            </div>
        </ng-container>
    </section>
</main>

<!-- Lista raggruppata per mese -->
<ng-template #groupedList let-groups="groups" let-past="past">
    <div class="flex flex-col gap-6">
        <section *ngFor="let group of groups; trackBy: trackByKey" [attr.aria-label]="group.date | date : 'MMMM y' : undefined : 'it'">
            <h3 class="mb-2 text-sm font-semibold capitalize text-slate-600">{{ group.date | date : 'MMMM y' : undefined : 'it' }}</h3>
            <ul class="m-0 flex list-none flex-col gap-3 p-0">
                <li *ngFor="let c of group.items; trackBy: trackById">
                    <a [routerLink]="detailRouteBase.concat(c.id)"
                       class="group flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-3 !text-strong !no-underline transition hover:border-primary hover:bg-primary-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary sm:gap-4 sm:p-4"
                       [attr.aria-label]="'Apri la convocazione ' + c.title">
                        <span class="grid h-14 w-14 shrink-0 place-content-center rounded-lg text-center"
                              [ngClass]="past ? 'bg-slate-100 text-slate-500' : 'bg-primary-soft text-primary'">
                            <span class="text-[10px] font-semibold uppercase leading-none">{{ c.date | date : 'EEE' : undefined : 'it' }}</span>
                            <span class="text-xl font-bold leading-tight">{{ c.date | date : 'd' : undefined : 'it' }}</span>
                            <span class="text-[10px] font-semibold uppercase leading-none">{{ c.date | date : 'MMM' : undefined : 'it' }}</span>
                        </span>

                        <span class="flex min-w-0 flex-1 flex-col gap-1">
                            <span class="flex min-w-0 items-start justify-between gap-2">
                                <span class="min-w-0 text-sm font-semibold leading-snug sm:text-base"
                                      [ngClass]="past ? 'text-slate-700' : 'text-strong'">{{ c.title }}</span>
                                <span class="hidden shrink-0 sm:inline-flex">
                                    <ng-container *ngTemplateOutlet="past ? pastBadge : invitedBadge; context: { $implicit: c }"></ng-container>
                                </span>
                            </span>
                            <span class="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-0.5 text-xs text-slate-500">
                                <span class="inline-flex items-center gap-1 whitespace-nowrap">
                                    <i class="bi bi-clock" aria-hidden="true"></i>
                                    {{ c.date | date : 'HH:mm' : undefined : 'it' }}
                                </span>
                                <span *ngIf="c.location" class="inline-flex min-w-0 items-center gap-1">
                                    <i class="bi bi-geo-alt shrink-0" aria-hidden="true"></i>
                                    <span class="truncate">{{ c.location }}<ng-container *ngIf="c.city"> · {{ c.city }}</ng-container></span>
                                </span>
                                <span *ngIf="c.categoryName" class="hidden items-center gap-1 md:inline-flex">
                                    <i class="bi bi-people" aria-hidden="true"></i>
                                    {{ c.categoryName }}
                                </span>
                            </span>
                            <span class="flex sm:hidden">
                                <ng-container *ngTemplateOutlet="past ? pastBadge : invitedBadge; context: { $implicit: c }"></ng-container>
                            </span>
                        </span>

                        <i class="bi bi-chevron-right shrink-0 text-slate-400 transition group-hover:translate-x-0.5 group-hover:text-primary" aria-hidden="true"></i>
                    </a>
                </li>
            </ul>
        </section>
    </div>
</ng-template>

<!-- Badge -->
<ng-template #invitedBadge let-c>
    <ng-container [ngSwitch]="isInvited(c)">
        <span *ngSwitchCase="true"
              class="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-emerald-50 px-2 py-0.5 text-xs font-semibold text-emerald-700">
            <i class="bi bi-check-circle" aria-hidden="true"></i> Sei convocato
        </span>
        <span *ngSwitchCase="false"
              class="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-600">
            <i class="bi bi-dash-circle" aria-hidden="true"></i> Non convocato
        </span>
    </ng-container>
</ng-template>

<ng-template #pastBadge let-c>
    <span *ngIf="isInvited(c) === true; else concluded"
          class="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-600">
        <i class="bi bi-check-circle" aria-hidden="true"></i> Eri convocato
    </span>
    <ng-template #concluded>
        <span class="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-500">
            <i class="bi bi-flag" aria-hidden="true"></i> Conclusa
        </span>
    </ng-template>
</ng-template>

<ng-template #countdownBadge let-c>
    <span class="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-soft px-2 py-0.5 text-xs font-semibold text-primary">
        <i class="bi bi-hourglass-split" aria-hidden="true"></i>
        <ng-container *ngIf="isToday(c)">Oggi</ng-container>
        <ng-container *ngIf="!isToday(c) && daysUntil(c) === 1">Domani</ng-container>
        <ng-container *ngIf="!isToday(c) && daysUntil(c) > 1">Tra {{ daysUntil(c) }} giorni</ng-container>
    </span>
</ng-template>

<!-- Stato vuoto -->
<ng-template #emptyState let-icon="icon" let-title="title" let-text="text">
    <div class="flex flex-col items-center rounded-xl border border-dashed border-slate-300 bg-white px-6 py-10 text-center">
        <span class="mb-3 grid h-12 w-12 place-items-center rounded-full bg-primary-soft text-xl text-primary">
            <i class="bi" [ngClass]="icon" aria-hidden="true"></i>
        </span>
        <p class="m-0 font-semibold text-strong">{{ title }}</p>
        <p class="mb-0 mt-1 max-w-sm text-sm text-slate-600">{{ text }}</p>
    </div>
</ng-template>

<!-- Skeleton -->
<ng-template #skeleton let-highlight="highlight">
    <div class="flex animate-pulse flex-col gap-3" role="status" aria-label="Caricamento convocazioni">
        <div *ngIf="highlight" class="mb-5 flex items-center gap-4 rounded-xl border border-slate-200 bg-white p-4 sm:p-5">
            <div class="h-16 w-16 shrink-0 rounded-xl bg-slate-200 sm:h-20 sm:w-20"></div>
            <div class="flex min-w-0 flex-1 flex-col gap-2">
                <div class="h-4 w-24 rounded bg-slate-100"></div>
                <div class="h-5 w-64 max-w-full rounded bg-slate-200"></div>
                <div class="h-3 w-48 max-w-full rounded bg-slate-100"></div>
            </div>
        </div>
        <div *ngFor="let row of [1, 2, 3]" class="flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-3 sm:gap-4 sm:p-4">
            <div class="h-14 w-14 shrink-0 rounded-lg bg-slate-200"></div>
            <div class="flex min-w-0 flex-1 flex-col gap-2">
                <div class="h-4 w-48 max-w-full rounded bg-slate-200"></div>
                <div class="h-3 w-32 rounded bg-slate-100"></div>
            </div>
        </div>
    </div>
</ng-template>
